import { getGoodsAndServicesTemplate } from "@/api/template";
import FileDownloader, { FileDownloaderProps } from "@/components/FileDownloader/FileDownloader";

export default function DownloadGoodsAndServicesTemplate(props: Partial<FileDownloaderProps>) {
  return (
    <FileDownloader
      fileOutputName={`template-goods-and-services.xlsx`}
      fileUrlFn={getGoodsAndServicesTemplate}
      {...props}
    />
  );
}
